import { v4 as uuidv4 } from 'uuid'

// FLAG:useDocuAi — operation ids exist only inside the invoice review. They are assigned when the
// reviewer adds a payment/assignment (not at Save time), so an HTTP retry carries the same id.
export const withReviewPaymentId = <T extends Record<string, unknown>>(
  payment: T,
  isDocumentInvoiceReviewMode: boolean,
  createId: () => string = uuidv4,
) => isDocumentInvoiceReviewMode
    ? { ...payment, reviewPaymentId: payment.reviewPaymentId || createId() }
    : payment
